/** @format */

import React from "react";

//material ui
import { Box } from "@mui/material";

//components
import HeroSection from "../components/FrequentQuestions/HeroSection";
import Sections from "../components/FrequentQuestions/Sections";

const useStyles = () => ({
	container: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
		textAlign: "center",
	},
});

const IntroductoryCourse = () => {
	const classes = useStyles();

	return (
		<>
			<Box sx={classes.container}>
				<HeroSection />
				<Sections />
			</Box>
		</>
	);
};

export default IntroductoryCourse;
